import React, { useEffect, useState, useContext, useCallback } from "react";

import {
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { MainContext } from "../../context/MainContext";
import PageTitle from "../../components/PageTitle/PageTitle";
import Api from "../../constant/Api";
import { useHistory } from "react-router-dom";
import { getRequest } from "../../constant/ApiService";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useStyles from "../../components/styles/styles";
import Input from "../../components/utils/Input";

const TransportationCompanyList = () => {
  const [items, setItems] = useState([]);
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();

  const [TransactionCompanySearch, setTransactionCompanySearch] = useState({
    name: "",
    managerName: "",
    managerPhone: "",
    tellNumber: "",
    contractNumber: "",
  });
  let { handleChangeRowsPerPage, rowsPerPage, page, setPage } = useContext(
    MainContext,
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getCustomerList = () => {
    getRequest(
      `${Api.GetTransportationCompanyList}?Name=${
        TransactionCompanySearch.name
      }&ManagerName=${TransactionCompanySearch.managerName}&MangerLastName=${
        TransactionCompanySearch.mangerLastName
      }&managerPhone=${TransactionCompanySearch.managerPhone}&TellNumber=${
        TransactionCompanySearch.tellNumber
      }&PageNumber=${page + 1}&PageSize=${rowsPerPage}`,
    ).then(res => {
      setItems(res && res.data);
    });
  };
  useEffect(() => {
    getCustomerList();
  }, []);

  const handleChangePage = (event, newPage) => {
    getCustomerList();
    setPage(newPage);
  };
  return (
    <Grid>
      <PageTitle title="لیست باربری" />
      <Grid container>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام </label>
          <Input
            name="name"
            value={TransactionCompanySearch.name}
            onChange={({ target }) =>
              setTransactionCompanySearch(state => ({
                ...state,
                name: target.value,
              }))
            }
            type="text"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام مدیر </label>
          <Input
            name="managerName"
            value={TransactionCompanySearch.managerName}
            onChange={({ target }) =>
              setTransactionCompanySearch(state => ({
                ...state,
                managerName: target.value,
              }))
            }
            type="text"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن مدیر</label>
          <Input
            name="managerPhone"
            value={TransactionCompanySearch.managerPhone}
            onChange={({ target }) =>
              setTransactionCompanySearch(state => ({
                ...state,
                managerPhone: target.value,
              }))
            }
            type="text"
          />
        </Grid>

        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن شرکت </label>
          <Input
            name="tellNumber"
            value={TransactionCompanySearch.tellNumber}
            onChange={({ target }) =>
              setTransactionCompanySearch(state => ({
                ...state,
                tellNumber: target.value,
              }))
            }
            type="tel"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن </label>
          <Input
            name="contractNumber"
            value={TransactionCompanySearch.contractNumber}
            onChange={({ target }) =>
              setTransactionCompanySearch(state => ({
                ...state,
                contractNumber: target.value,
              }))
            }
            type="tel"
          />
        </Grid>
        <Grid
          container
          justifyContent="space-between"
          direction="row-reverse"
          style={{ padding: "20px 0" }}
        >
          <Grid style={{ display: "flex" }}>
            <Button
              variant="contained"
              style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
              onClick={getCustomerList}
            >
              جستجو کنید
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>ردیف</TableCell>
              <TableCell>شناسه</TableCell>
              <TableCell> نام </TableCell>
              <TableCell> نام شهر</TableCell>
              <TableCell>آدرس</TableCell>
              <TableCell>تلفن شرکت</TableCell>
              <TableCell>نام مدیر</TableCell>
              <TableCell>موبایل مدیر </TableCell>
              <TableCell>شماره قرارداد</TableCell>
              <TableCell> تاریخ قرارداد </TableCell>
              <TableCell>نام کاربری </TableCell>
              <TableCell>کلمه عبور </TableCell>
              <TableCell>اقدام</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items &&
              items.lists &&
              items.lists.length > 0 &&
              items.lists.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.id}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.name}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.cityName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.address}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.tellNumber}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.managerName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.managerPhone}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.contractNumber}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.contractDate}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.userName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailTransportationCompany/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.password}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          width: "20ch",
                        },
                      }}
                    >
                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="primary"
                        >
                          مدیریت مالی
                        </Button>
                      </MenuItem>

                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="secondary"
                          // onClick={()=>deleteCargoFunc(item.id)}
                        >
                          قراردادی
                        </Button>
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {console.log(page)}
      <TablePagination
        labelRowsPerPage=""
        rowsPerPageOptions={[]}
        component="div"
        count={items && items.count > 0 ? items.count : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
};
export default TransportationCompanyList;
